/* eslint-disable react/no-danger */
/* eslint react/no-did-mount-set-state: 0 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {MoreOrLess} from '@homeaway/react-collapse';
import {pushEdapEvent} from '../../../utils/edap';
import EdapViewTracker from '../../common/edap-view-tracker/EdapViewTracker';

import './styles.less';

const COLLAPSED_TEXT_MAX_HEIGHT = 96;
const MAX_LINE_COUNT = 4;

export function mapStateToProps(state) {
    const {
        config: {isMobile},
        modules: {
            seoIntroduction: {labels, introduction},
        },
        abacus,
    } = state;

    return {
        labels,
        introduction,
        isMobile,
        abacus,
    };
}

export class SEOIntroductionParagraphComponent extends PureComponent {
    static propTypes = {
        id: PropTypes.string,
        introduction: PropTypes.string.isRequired,
        labels: PropTypes.shape({
            buttonViewLess: PropTypes.string,
            buttonViewMore: PropTypes.string,
        }),
        ACTION_LOCATION: PropTypes.string,
        isMobile: PropTypes.bool,
    };

    static defaultProps = {
        id: 'seo-introduction-paragraph-id',
        ACTION_LOCATION: 'collapsible-paragraph',
        isMobile: false,
    };

    constructor(props) {
        super(props);

        this.state = {
            lineCount: 0,
        };

        this.introRef = React.createRef(null);
    }

    componentDidMount() {
        this.setLineCount();
    }

    setLineCount = () => {
        const {current = {}} = this.introRef;
        const {clientHeight = 0} = current || {};
        const lineCount =
            clientHeight > COLLAPSED_TEXT_MAX_HEIGHT ? MAX_LINE_COUNT : 0;

        this.setState({lineCount});
    };

    onViewMoreOrLessClick = (isExpanded) => {
        const {ACTION_LOCATION} = this.props;

        pushEdapEvent('generic.event', {
            actionlocation: ACTION_LOCATION,
            eventcategory: 'interaction-click',
            eventaction: isExpanded ? 'expand' : 'collapse',
            eventrefinements: 'DEST_INTRO',
        });
    };

    render() {
        const {id, labels, introduction, ACTION_LOCATION, content} = this.props;

        const collapsibleContentProps = {
            lines: this.state.lineCount,
            moreText: labels.buttonViewMore,
            lessText: labels.buttonViewLess,
            onExpandedChange: this.onViewMoreOrLessClick,
        };

        const showMoreLessButton =
            this.state.lineCount > 0 ? collapsibleContentProps : {};

        return content || introduction ? (
            <div className={'seo-introduction-paragraph container module'}>
                {
                    <MoreOrLess
                        id={id}
                        expanded={false}
                        {...showMoreLessButton}
                    >
                        <div
                            className="collapsible-content__body-text"
                            ref={this.introRef}
                        >
                            {introduction}
                        </div>
                    </MoreOrLess>
                }
                <EdapViewTracker eventData={{actionlocation: ACTION_LOCATION}}>
                    <div style={{minHeight: '1px', clear: 'both'}} />
                </EdapViewTracker>
            </div>
        ) : null;
    }
}

export const SEOIntroductionParagraph = connect(mapStateToProps)(
    SEOIntroductionParagraphComponent
);

SEOIntroductionParagraph.displayName = 'SEOIntroductionParagraph';

export default SEOIntroductionParagraph;
